import { omitBy } from 'lodash';
import base from './baseApi';
import { createSearchParams } from 'react-router';
const { get, post, patch } = base();

export const searchRegion = (payload: any) => {
   return post('region/search', payload);
};

export const searchHotel = (payload: any, recaptchaToken?: string | null, isCheckbox = false, signal?: AbortSignal) => {
   const headers: Record<string, any> = {};
   if (recaptchaToken) {
      headers['x-recaptcha-token'] = recaptchaToken;
      if (isCheckbox) headers['x-recaptcha-checkbox'] = 'true';
   }
   // `signal` must be forwarded: without it a superseded search runs to completion against the
   // 180s global timeout and its result is silently discarded (NPT-1500).
   return post(`hotel/serp`, payload, headers, undefined, signal);
};

export const getStaticHotels = (payload: any) => {
   return post(`hotel/static-list`, payload);
};

export const getHotelDetail = (id: any, query: any, payload: any) => {
   const initParams: any = omitBy(query, v => v === '');
   const params = createSearchParams(initParams);
   return post(`/hotel/${id}/retrieve?${params.toString()}`, payload);
};

export const getHotelPreview = (id: string) => {
   return get(`/hotel/${id}/preview`);
};

export const getHotelRates = (id: any, query: any, payload: any) => {
   const initParams: any = omitBy(query, v => v === '');
   const params = createSearchParams(initParams);
   return post(`/hotel/${id}/rates?${params.toString()}`, payload);
};

export const getSimilarHotels = (id: any, query: any, payload: any) => {
   const initParams: any = omitBy(query, v => v === '');
   const params = createSearchParams(initParams);
   return post(`/hotel/${id}/similar-hotel?${params.toString()}`, payload);
};

export const getHotelCommission = ({ id, payload }: any) => {
   return post(`/hotel/${id}/commission`, payload);
};

export const getHotelImages = (ids: string[]) => {
   return post('/hotel/images', ids);
};

export const getHotelRatings = ({ countryCode, hotels }: any) => {
   const params = createSearchParams({ countryCode });
   return post(`/hotel/ratings?${params}`, hotels);
};

export const getHotelReviews = ({ id, ratingId, nextPageToken, sortBy }: any) => {
   return post(`/hotel/${id}/reviews`, { ratingId, nextPageToken, sortBy });
};

export const getHotelStatic = () => get(`/hotel/static`);

export const updateRatingData = (hotelId: string, payload: any) => {
   return patch(`/static/rating/${hotelId}/update`, payload);
}
